import { Container } from "@material-ui/core";
import React from "react";
import UserSummary from "./UserSummary";

const Dashboard = () => {
  return (
    <Container>
      <UserSummary />
    </Container>
  );
};

export default Dashboard;
